import { jsx as n } from "react/jsx-runtime";
import { f as e, n as s } from "../../vendor--aJiswR_.js";
import { getButtonStyles as a } from "../BaseButton/index.js";
import '../../assets/index10.css';const c = "_skipToContent_15f6p_1", r = {
  skipToContent: c
}, f = ({ targetId: t = "main-content" }) => {
  const o = e(a({ variant: "secondary" }), r.skipToContent);
  return /* @__PURE__ */ n(
    s,
    {
      href: `#${t}`,
      className: o,
      target: "_self",
      "data-component": "SkipToContent",
      children: "Skip to main content"
    }
  );
};
export {
  f as SkipToContent
};
//# sourceMappingURL=index.js.map
